export const headers = {
    initialHeaders: [
        { title: "Nombres", field: "name", child: null },
        {title: "Apellidos", field: "surname", child: null,},
        { title: "Tipo de documento", field: "documentType", child: null },
        { title: "Número de documento", field: "document", child: null },
        {title: "Estado", field: "status", child: null,},
    ],
    othersHeaders: [
        { title: "Segundo nombre", field: "secondName", child: null },
        { title: "Segundo apellido", field: "secondSurname", child: null },
        { title: "Tipo de documento", field: "documentType", child: null },
        { title: "Número de documento", field: "document", child: null },
        { title: "Correo personal", field: "personalEmail", child: null },
        { title: "Rol", field: "rol", child: null },
        { title: "Teléfono fijo", field: "phone", child: null },
        { title: "Celular", field: "movil", child: null },
        { title: "Género", field: "gender", child: null },
        { title: "Fecha de creación", field: "creationDate", child: null },
    ]
}

export const defaultValue = {
    email: null,
    firstName: null,
    surname: null,
    documentType: null,
    document: null,
    status: null,
    initDate: null,
    endDate: null,
    chargeDenomination: null,
}